import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { Session } from '@services/session';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';
import { ECOMM_ELIGIBLE_ENTITIES } from '@app/admin/shop/ecomm-eligible-entities';

@Injectable()
export class ShopGuard implements CanActivate {
  constructor(
    private router: Router,
    private session: Session,
    private fgFeatureFlagService: FleetGrowthFeatureFlagService,
  ) {}

  public canActivate(): boolean {
    if (!ECOMM_ELIGIBLE_ENTITIES.EXPERIMENT.includes(this.session.getEcommEligibility()) ||
        this.fgFeatureFlagService.isContactSalesExperimentEnabled()) {
      return true;
    }

    this.router.navigate(['/admin']);
    return false;
  }
}
